import { cloudChiprApi } from "../../../services/cloudchipr.api";

export const categoryByIdSelector =
  cloudChiprApi.endpoints.getUsersMeCategoriesByCategoryId.select;
